/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

import {vec3} from "gl-matrix";
import DrawableObject from "App/environment/drawable_object";
import IScene from "js_interface/src/scene_interface";

export default
class Grass extends DrawableObject {
    constructor(sceneAPI: IScene, gl: WebGLRenderingContext) {

        let origin = vec3.fromValues(0, 0, 0);

        // Rotate 0
        let pos: vec3[] = [];
        pos[0] = vec3.fromValues(-1, 2, 0);
        pos[1] = vec3.fromValues(-1, 0, 0);
        pos[2] = vec3.fromValues(1, 2, 0);
        pos[3] = vec3.fromValues(1, 0, 0);

        let normal: vec3 = vec3.fromValues(0, 1, 1);
        vec3.normalize(normal, normal);

        let vertices: number[] = [];
        Grass._copyVertices(vertices, pos, normal);

        // Rotate 1
        for (let i = 0; i < 4; i++) {
            vec3.rotateY(pos[i], pos[i], origin, 3.14 / 3.0);
        }
        vec3.rotateY(normal, normal, origin, 3.14 / 3.0);
        Grass._copyVertices(vertices, pos, normal);

        // Rotate 2
        for (let i = 0; i < 4; i++) {
            vec3.rotateY(pos[i], pos[i], origin, 3.14 / 3.0);
        }
        vec3.rotateY(normal, normal, origin, 3.14 / 3.0);
        Grass._copyVertices(vertices, pos, normal);

        // Rotate 3
        for (let i = 0; i < 4; i++) {
            vec3.rotateY(pos[i], pos[i], origin, 3.14 / 3.0);
        }
        vec3.rotateY(normal, normal, origin, 3.14 / 3.0);
        Grass._copyVertices(vertices, pos, normal);

        // Rotate 4
        for (let i = 0; i < 4; i++) {
            vec3.rotateY(pos[i], pos[i], origin, 3.14 / 3.0);
        }
        vec3.rotateY(normal, normal, origin, 3.14 / 3.0);
        Grass._copyVertices(vertices, pos, normal);

        // Rotate 5
        for (let i = 0; i < 4; i++) {
            vec3.rotateY(pos[i], pos[i], origin, 3.14 / 3.0);
        }
        vec3.rotateY(normal, normal, origin, 3.14 / 3.0);
        Grass._copyVertices(vertices, pos, normal);

        // Indices
        let indices = [
            0, 1, 2,
            1, 3, 2,

            4, 5, 6,
            5, 7, 6,

            8, 9, 10,
            9, 11, 10,

            12, 13, 14,
            13, 15, 14,

            16, 17, 18,
            17, 19, 18,

            20, 21, 22,
            21, 23, 22
        ];

        super(sceneAPI, gl, vertices, indices, 3, 3, 2, false);

        this.setPlaceholderColor(0, 150, 0);
        this._vboMethod = gl.TRIANGLES;
    }

    private static _copyVertices(array: number[], position: vec3[], normal: vec3) {
        for (let i = 0; i < 4; i++) {
            // Position
            for (let a = 0; a < 3; a++) {
                array.push(position[i][a]);
            }

            // Normal
            array.push(normal[0]);
            array.push(normal[1]);
            array.push(normal[2]);

            // Texcoords
            switch (i) {
                case 0:
                    array.push(0);
                    array.push(1);
                    break;
                case 1:
                    array.push(0);
                    array.push(0);
                    break;
                case 2:
                    array.push(1);
                    array.push(1);
                    break;
                case 3:
                    array.push(1);
                    array.push(0);
                    break;
            }
        }
    }
}
